// make sure lang in format: en-HK (regions should be CAPITAL)
export const getCapitalizedRegionLang = (lang) =>
  lang.replace(/(\w+)-(\w+)/, (match, p1, p2) => `${p1}-${p2.toUpperCase()}`);



// WEBPACK FOOTER //
// ./src/utils/langParser.js